import * as React from "react";
import {TextareaAutosize}  from "react-autosize-textarea/lib/TextareaAutosize";

import "./template-configurations.scss";

import {cx}                from "emotion";
import {bindInput}         from "@Common/react/bind-input";
import {scopedState}       from "@Common/react/scoped-state";
import {getBindingResults} from "@Common/tools/cc-integration/cc-editor/get-binding-results";
import {Select2}           from "@Common/ui-components/select-2/select-2";
import {SliderCheckbox}    from "@Common/ui-components/slider-checkbox/slider-checkbox";

import {
    faArrowsLeftRightToLine, faCircleChevronDown, faDownLeftAndUpRightToCenter, faFont, faLink, faMaximize,
    faQrcode, faScissors
} from "@fortawesome/free-solid-svg-icons";
import {faAddressBook, faImage} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const templateConfigurations = ( item, company, companyGallery, data1, data2, dataProperties, getProduct, mockDataFormatted, photoServices, reloadItems ) => {
    let inputType = scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "type"]).value;
    let qrType = scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).value ?? [];

    return <div className="template-configurations-3s6">
        {item.type ==="BoundedTextItem" || item.type === "PathBoundedTextItem" || item.type === "PlainTextItem"
            ? <>
                {item.isRichText || item.textPermissions.allowTextFormatting
                    ? <>Text binding features temporarily unavailble for rich text fields.</>
                    : <>
                        <div className="field">
                            <div className="label uppercase">
                                Input Type
                            </div>
                            <div className="control">
                                <button className={!inputType || inputType == 'textArea' ? 'active': ''}
                                    aria-label="Textarea"
                                    xd-qa-type="button"
                                    xd-qa-name="Input Type Textarea"
                                    onClick={()=>{
                                        let currentValue = scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "type"]).value;
                                        scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('textArea');
                                        if(currentValue && ['dropdown', 'userSearch', 'officeSearch'].includes(currentValue)) {
                                            let bindingValue = scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value
                                            if(bindingValue) {
                                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('inlineVariable');
                                            }
                                            else {
                                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('');
                                            }
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFont} />
                                </button>
                                <button className={inputType == 'dropdown' ? 'active': ''}
                                    aria-label="Dropdown - Use new lines to separate dropdown options."
                                    xd-qa-type="button"
                                    xd-qa-name="Input Type Dropdown"
                                    onClick={()=>{
                                        scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('dropdown');
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('dropdown');
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCircleChevronDown} />
                                </button>
                            </div>
                        </div>
                        <div className="field">
                            <div className="label uppercase">
                                {inputType == 'dropdown' ? 'Dropdown Options' : 'Default Text' }
                            </div>
                            <div className="control">
                                <TextareaAutosize {...{
                                    placeholder: inputType == 'dropdown' ? "Use new lines to separate dropdown options." : "Default text binding or static text.",
                                    value: scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value,
                                    "xd-qa-type":"textarea",
                                    "xd-qa-name":"bindingValue",
                                    onChange: (e) => {
                                        let value = scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "type"]).value
                                        if(e.target?.value){
                                            scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange(
                                                value == 'dropdown' ? value: 'inlineVariable'
                                            );
                                        }
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).onChange(e.target?.value);
                                    }
                                }} />
                                {scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value
                                    ? <TextareaAutosize className="readOnly" readOnly={true} value={
                                        getMockedResult(mockDataFormatted, scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value ?? '')
                                    } />
                                    : <></>
                                }
                            </div>
                        </div>
                        <div className="field">
                            <div className="label uppercase">
                                Info Tip
                            </div>
                            <div className="control">
                                <TextareaAutosize {...bindInput(scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "infoTip"]))}
                                    xd-qa-type="textarea"
                                    xd-qa-name="Info Tip"
                                />
                            </div>
                        </div>
                        <div className="field">
                            <div className="label uppercase">
                                Formatting
                            </div>
                            <div className="control">
                                {Select2({
                                    list: [
                                        "",
                                        "usd",
                                        "000.000.0000",
                                        "000-000-0000",
                                        "000 000 0000",
                                        "(000) 000.0000",
                                        "(000) 000-0000",
                                        "(000) 000 0000",
                                        "+1 000.000.0000",
                                        "+1 000-000-0000",
                                        "+1 000 000 0000",
                                        "+1 (000) 000.0000",
                                        "+1 (000) 000-0000",
                                        "+1 (000) 000 0000",
                                        "000 000-000",
                                        "+1 000 000-0000"
                                    ],
                                    getLabel: (value) => value,
                                    isSelected: (i) => i === scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "inputMask"]).value,
                                    onSelect:  (value) => scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "inputMask"]).onChange(value),
                                    xdQaName: "inputMask"
                                })}
                            </div>
                        </div>
                        <div className="field flexField">
                            <div className="label">
                                Use Suggested Comments
                            </div>
                            <div className="control">
                                {SliderCheckbox({
                                    xdQaName: "useSuggested",
                                    value: scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "useSuggested"]).value,
                                    onChange: () => scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "useSuggested"]).onChange(
                                        !scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "useSuggested"]).value
                                    )
                                })}
                            </div>
                        </div>
                    </>
                }
                <div className="field flexField">
                    <div className="label">
                        Required Field
                    </div>
                    <div className="control">
                        {SliderCheckbox({
                            xdQaName: "isRequired",
                            value: scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).value,
                            onChange: () => scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).onChange(
                                !scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).value
                            )
                        })}
                    </div>
                </div>
                <div className={"field"}>
                    <div className="label uppercase">
                        Text Overflow Strategy
                    </div>
                    <div className="control">
                        <button className={item.overflowStrategy == 1 ? 'active' : ''}
                            aria-label="Fit to Width"
                            xd-qa-type="button"
                            xd-qa-name="Overflow Fit to Width"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['overflowStrategy'] = 1;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "overflowStrategy"]).onChange('fitToWidth');
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowsLeftRightToLine} />
                        </button>
                        <button className={item.overflowStrategy == 2 ? 'active' : ''}
                            aria-label="Fit to Box"
                            xd-qa-type="button"
                            xd-qa-name="Overflow Fit to Box"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['overflowStrategy'] = 2;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "overflowStrategy"]).onChange('fitToBox');
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faMaximize} />
                        </button>
                        <button className={!item.overflowStrategy ? 'active' : ''}
                            aria-label="Clip"
                            xd-qa-type="button"
                            xd-qa-name="Overflow Clip"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['overflowStrategy'] = 0;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "overflowStrategy"]).onChange('clip');
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faScissors} />
                        </button>
                    </div>
                </div>
                <div className={"field flexField"}>
                    <div className="label">
                        Text Placeholder
                    </div>
                    <div className="control">
                        {SliderCheckbox({
                            xdQaName: "Text Placeholder",
                            value: item.isTextPlaceholder,
                            onChange: async (value) => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['_originalText'] = itemChanging['_text'];
                                    itemChanging['isTextPlaceholder'] = value;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'isTextPlaceholder']).onChange(value);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }
                        })}
                    </div>
                </div>
            </>
            : item.type === "BarcodeItem" || item.type === "ImageItem" || item.type === "PlaceholderItem"
            ? <>
                <div className="field flexField">
                    <div className="label">
                        Required Field
                    </div>
                    <div className="control">
                        {SliderCheckbox({
                            xdQaName: "isRequired",
                            value: scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).value,
                            onChange: () => scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).onChange(
                                !scopedState(data1, [item.parentContainer.parentComponent.name, item.name, "isRequired"]).value
                            )
                        })}
                    </div>
                </div>
                <div className="field">
                    <div className="label uppercase">
                        Input Type
                    </div>
                    <div className="control">
                        <button className={!scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).value
                                || scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).value == 'image' ? 'active' : ''
                            }
                            aria-label="Image"
                            xd-qa-type="button"
                            xd-qa-name="Input Type Image"
                            onClick={()=>{
                                let currentType = scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).value;
                                if( currentType === 'qrCode' ) {
                                    if( scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value ) {
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('image');
                                    }
                                    else {
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('');
                                    }
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faImage} />
                        </button>
                        <button className={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).value == 'qrCode' ? 'active': ''}
                            aria-label="QR Code"
                            xd-qa-type="button"
                            xd-qa-name="Input Type QR Code"
                            onClick={()=>{
                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('qrCode');
                            }}
                        >
                            <FontAwesomeIcon icon={faQrcode} />
                        </button>
                    </div>
                </div>

                {(scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).value == "qrCode") ? <>
                    <div className="field">
                        <div className="label uppercase">
                            QR Type
                        </div>
                        <div className="control">
                            <button className={qrType.indexOf('vcard') !== -1 ? 'active': ''}
                                aria-label="vCard"
                                xd-qa-type="button"
                                xd-qa-name="QR Type vCard"
                                onClick={() => scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).onChange(['vcard'])}
                            >
                                <FontAwesomeIcon icon={faAddressBook} />
                            </button>
                            <button className={qrType.indexOf('url') !== -1 ? 'active': ''}
                                aria-label="URL"
                                xd-qa-type="button"
                                xd-qa-name="QR Type URL"
                                onClick={() => scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).onChange(['url'])}
                            >
                                <FontAwesomeIcon icon={faLink} />
                            </button>
                            <button className={qrType.length == 2 ? 'active': ''}
                                aria-label="Both"
                                style={{width:'46px'}}
                                xd-qa-type="button"
                                xd-qa-name="QR Type Both"
                                onClick={() => scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).onChange([
                                    'vcard',
                                    'url',
                                ])}
                            >
                                Both
                            </button>
                        </div>
                    </div>
                    { scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).value?.includes('vcard')
                        ? <>{Object.entries({
                                'QR First Name': 'firstName', 'QR Last Name': 'lastName', 'QR Title Name': 'title', 'QR Organization': 'org', 'QR Email': 'email',
                                'QR Phone Number': 'phone', 'QR Fax Number': 'fax', 'QR Street Address': 'streetAddress', 'QR City': 'city', 'QR State': 'state',
                                'QR Zip/Postal Code': 'zip', 'QR Country': 'country'
                            }).map(([label, key]) => (
                                <div className="field">
                                    <div className="label uppercase">{label}</div>
                                    <div className="qrPrefs">
                                        <TextareaAutosize {...bindInput(scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", key]))}
                                            placeholder={label}
                                            xd-qa-type="textarea"
                                            xd-qa-name={label}
                                        />
                                        {scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", key]).value
                                            ? <TextareaAutosize className="readOnly" readOnly={true} value={
                                                getMockedResult(mockDataFormatted, scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", key]).value ?? '')
                                            } />
                                            :<></>
                                        }
                                    </div>
                                    <div className="qrPrefsCheckbox">
                                        <input
                                            type="checkbox"
                                            checked={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "isRequired"]).value}
                                            xd-qa-type="checkbox"
                                            xd-qa-name="Required"
                                            onChange={() =>
                                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "isRequired"]).onChange(
                                                    !scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "isRequired"]).value
                                                )
                                            }
                                        />Required
                                        <input
                                            className="leftSpacing"
                                            type="checkbox"
                                            checked={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "readOnly"]).value}
                                            xd-qa-type="checkbox"
                                            xd-qa-name="Read Only"
                                            onChange={() =>
                                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "readOnly"]).onChange(
                                                    !scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "readOnly"]).value
                                                )
                                            }
                                        />Read Only
                                    </div>
                                    { key === 'email' ? <div className="qrPrefsCheckbox">
                                            <input
                                                type="checkbox"
                                                checked={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "specifiedDomain"]).value}
                                                xd-qa-type="checkbox"
                                                xd-qa-name="Use Specified Domain"
                                                onChange={() =>
                                                    scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "specifiedDomain"]).onChange(
                                                        !scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", key, "specifiedDomain"]).value
                                                    )
                                                }
                                            />Use Specified Domain
                                        </div>
                                        : ''
                                    }
                                </div>
                            ))}
                        </>
                        : ''
                    }
                    { scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).value?.includes('vcard')
                        || scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrType"]).value?.includes('url')
                        ? <div className="field">
                            <div className="label uppercase">QR Website URL</div>
                            <div className="qrPrefs">
                                <TextareaAutosize {...bindInput(scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", "url"]))}
                                    placeholder="QR Website URL"
                                    xd-qa-type="textarea"
                                    xd-qa-name="QR Website URL"
                                />
                                {scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", 'url']).value
                                    ? <TextareaAutosize className="readOnly" readOnly={true} value={
                                        getMockedResult(mockDataFormatted, scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qr", "url"]).value ?? '')
                                    } />
                                    : <></>
                                }
                            </div>
                            <div className="qrPrefsCheckbox">
                                <input
                                    type="checkbox"
                                    checked={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "isRequired"]).value}
                                    xd-qa-type="checkbox"
                                    xd-qa-name="Required"
                                    onChange={() =>
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "isRequired"]).onChange(
                                            !scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "isRequired"]).value
                                        )
                                    }
                                />Required
                                <input
                                    className="leftSpacing"
                                    type="checkbox"
                                    checked={scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "readOnly"]).value}
                                    xd-qa-type="checkbox"
                                    xd-qa-name="Read Only"
                                    onChange={() =>
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "readOnly"]).onChange(
                                            !scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "readOnly"]).value
                                        )
                                    }
                                />Read Only<br/>
                            </div>
                            <div className="qrPrefs">QR Website URL Prefix
                                <TextareaAutosize {...bindInput(scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "qrPrefs", 'url', "prefix"]))}
                                    placeholder="QR Website URL Prefix"
                                    xd-qa-type="textarea"
                                    xd-qa-name="QR Website URL Prefix"
                                />
                            </div>
                        </div>
                        : ''
                    }
                </> : <div className="field">
                    <div className="label uppercase">
                        Default Image Binding
                    </div>
                    {Select2({
                        list: variableImageBindingExamples,
                        getLabel: (i) => i.name,
                        isSelected: (i) => i.binding === scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value,
                        onSelect: (i) => {
                            if(i?.binding){
                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('image');
                            }
                            else {
                                scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('');
                            }
                            scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).onChange(i?.binding);
                        },
                        placeholder: 'Select or Use Custom',
                        xdQaName: "ImageBinding"
                    })}
                    {variableImageBindingExamples.findIndex((value)=>{
                        return value.binding == scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value
                     }) == -1 ? <>
                        <div className="label uppercase">
                            Custom Image Binding
                        </div>
                        <div className="control">
                            <TextareaAutosize {...{
                                value: scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value,
                                onChange: (e) => {
                                    if(e.target?.value){
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('image');
                                    }
                                    else {
                                        scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "type"]).onChange('');
                                    }
                                    scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).onChange(e.target?.value);
                                },
                                "xd-qa-type":"textarea",
                                "xd-qa-name":"bindingValue"
                            }} />
                            {scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value
                                ? <TextareaAutosize className="readOnly" readOnly={true} value={
                                    getMockedResult(mockDataFormatted, scopedState(data2, [item.parentContainer.parentComponent.name, item.name, "value"]).value ?? '')
                                } />
                                : <></>
                            }
                        </div>
                    </>:<></>}
                </div>}
                <div className="field">
                    <div className="label uppercase">
                        Placeholder Resize Mode
                    </div>
                    <div className="control">
                        <button className={!item.contentResizeMode ? 'active' : ''}
                            aria-label="Fit"
                            xd-qa-type="button"
                            xd-qa-name="Content Resize Fit"
                            disabled={item.isCoverMode}
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentResizeMode'] = 0;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentResizeMode"]).onChange(0);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} />
                        </button>
                        <button className={item.contentResizeMode == 1 ? 'active' : ''}
                            aria-label="Fill"
                            xd-qa-type="button"
                            xd-qa-name="Content Resize Fill"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentResizeMode'] = 1;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentResizeMode"]).onChange(1);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faArrowsLeftRightToLine} />
                        </button>
                    </div>
                </div>
                <div className="field">
                    <div className="label uppercase">
                        Allowed Galleries
                    </div>
                    <div className="control">
                        <div className="grid" xd-qa-name="Allowed Galleries" xd-qa-type="multi-select">
                            {["Agent Logo Gallery", "Brand Logo Gallery", "Designation Gallery", "Headshot Gallery", "Property Photos"].map((o, i) => {
                                const selected = item.allowedTabs && item.allowedTabs?.indexOf(o) >=0;
                                return (
                                    <button
                                        className={cx({active: !item.allowedTabs || selected})}
                                        xd-qa-name={(!item.allowedTabs || selected) ? o + " checked" : o}
                                        xd-qa-type="button"
                                        key={i}
                                        disabled={o=="Designation Gallery" && !company?.imageGallery?.designations?.length}
                                        onClick={async () => {
                                            try{
                                                let value = selected ? (
                                                    item.allowedTabs.filter((item) => item !== o)
                                                ) : (item.allowedTabs ? [
                                                        ...item.allowedTabs,
                                                        o,
                                                    ] : [
                                                        "Agent Logo Gallery", "Brand Logo Gallery", "Designation Gallery", "Headshot Gallery", "Property Photos", "Photo Album"
                                                    ].filter((item) => item !== o)
                                                );
                                                if( o == "Property Photos" ) {
                                                    value = selected ? (
                                                        value.filter((item) => item !== "Photo Album")
                                                    ) : [
                                                        ...value,
                                                        "Photo Album",
                                                    ];
                                                }
                                                let product = await getProduct();
                                                let itemChanging = await product.getItemByName(item.name);
                                                itemChanging['allowedTabs'] = value;
                                                if(itemChanging['_content']) {
                                                    itemChanging['_content']['allowedTabs'] = value;
                                                }
                                                await product.setItem(itemChanging);
                                                await reloadItems();
                                                scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'allowedTabs']).onChange(value);
                                            }
                                            catch(error){
                                                console.log('Error:', error);
                                            }
                                        }}
                                    >
                                        {o == 'Property Photos' ? 'Specialty Galleries' : o == 'Designation Gallery' ? 'Business Card Designations' : o}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {(!item.allowedTabs || item.allowedTabs?.indexOf('Property Photos') >=0) && <div className="field">
                    <div className="label uppercase">
                        Allowed Specialty Galleries
                    </div>
                    <div className="control">
                        <div className="grid" xd-qa-name="Allowed Specialty Galleries" xd-qa-type="multi-select">
                            <button key={'Upload'} className={cx({active: !scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Upload')})}
                                xd-qa-name={!scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Upload') ? 'Upload' + " checked" : 'Upload'}
                                xd-qa-type="button"
                                onClick={() => {
                                    const value = scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value ?? [];
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).onChange(
                                        value.includes('Upload') ? value.filter(v => v !== 'Upload') : value.concat('Upload')
                                    );
                                }}
                            >
                                Order Upload Gallery
                            </button>
                            <button key={'Previous Orders'} className={cx({
                                    active: !company.prefs?.customersCanvasUsesDefaultAssetManager
                                        && !scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Previous Orders')
                                })}
                                xd-qa-name={!scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Previous Orders') ? 'Previous Orders' + " checked" : 'Previous Orders'}
                                xd-qa-type="button"
                                disabled={company.prefs?.customersCanvasUsesDefaultAssetManager}
                                onClick={() => {
                                    const value = scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value ?? [];
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).onChange(
                                        value.includes('Previous Orders') ? value.filter(v => v !== 'Previous Orders') : value.concat('Previous Orders')
                                    );
                                }}
                            >
                                Previous Orders
                            </button>
                            <button key={'Company Gallery'} className={cx({
                                    active: companyGallery.value?.length && !company.prefs?.customersCanvasUsesDefaultAssetManager
                                        && !scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Company Gallery')
                                })}
                                xd-qa-name={!scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Company Gallery') ? 'Company Gallery' + " checked" : 'Company Gallery'}
                                xd-qa-type="button"
                                disabled={!companyGallery.value?.length || company.prefs?.customersCanvasUsesDefaultAssetManager}
                                onClick={() => {
                                    const value = scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value ?? [];
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).onChange(
                                        value.includes('Company Gallery') ? value.filter(v => v !== 'Company Gallery') : value.concat('Company Gallery')
                                    );
                                }}
                            >
                                Company Gallery
                            </button>
                            <button key={'Photo Services'} className={cx({
                                    active: photoServices.value?.length && !company.prefs?.customersCanvasUsesDefaultAssetManager
                                        && !scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Photo Services')
                                })}
                                xd-qa-name={!scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value?.includes('Photo Services') ? 'Photo Services' + " checked" : 'Photo Services'}
                                xd-qa-type="button"
                                disabled={!photoServices.value?.length || company.prefs?.customersCanvasUsesDefaultAssetManager}
                                onClick={() => {
                                    const value = scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).value ?? [];
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'excludeOrderGallery']).onChange(
                                        value.includes('Photo Services') ? value.filter(v => v !== 'Photo Services') : value.concat('Photo Services')
                                    );
                                }}
                            >
                                Photo Services
                            </button>
                        </div>
                    </div>
                </div>}
                <div className="field">
                    <div className="label uppercase">
                        Link Photos With Id
                    </div>
                    <div className="control">
                        <input
                            type='text'
                            defaultValue={item.linkId}
                            onInput={async(e) => {
                                try{
                                    let value = e.currentTarget.value;
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['linkId'] = value;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "linkId"]).onChange(
                                        value
                                    );
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                            xd-qa-name={'Link Id'}
                            xd-qa-type="input"
                        />
                    </div>
                </div>
                <div className="field">
                    <div className="label uppercase">
                        Horizontal Align(On Upload)
                    </div>
                    <div className="control">
                        <button className={item.contentHorizontalAlignment == 3 ? 'active' : ''}
                            aria-label="Left Align"
                            xd-qa-type="button"
                            xd-qa-name="Horizontal Align Left"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentHorizontalAlignment'] = 3;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentHorizontalAlignment"]).onChange(3);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-horiz-left"></span>
                        </button>
                        <button className={!item.contentHorizontalAlignment ? 'active' : ''}
                            aria-label="Center Align"
                            xd-qa-type="button"
                            xd-qa-name="Horizontal Align Center"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentHorizontalAlignment'] = 0;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentHorizontalAlignment"]).onChange(0);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-horiz-center"></span>
                        </button>
                        <button className={item.contentHorizontalAlignment == 2 ? 'active' : ''}
                            aria-label="Right Align"
                            xd-qa-type="button"
                            xd-qa-name="Horizontal Align Right"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentHorizontalAlignment'] = 2;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentHorizontalAlignment"]).onChange(2);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-horiz-right"></span>
                        </button>
                    </div>
                </div>
                <div className="field">
                    <div className="label uppercase">
                        Vertical Align(On Upload)
                    </div>
                    <div className="control">
                        <button className={item.contentVerticalAlignment == 2 ? 'active' : ''}
                            aria-label="Top Align"
                            xd-qa-type="button"
                            xd-qa-name="Vertical Align Top"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentVerticalAlignment'] = 2;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentVerticalAlignment"]).onChange(2);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-vert-top"></span>
                        </button>
                        <button className={!item.contentVerticalAlignment ? 'active' : ''}
                            aria-label="Center Align"
                            xd-qa-type="button"
                            xd-qa-name="Vertical Align Center"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentVerticalAlignment'] = 0;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentVerticalAlignment"]).onChange(0);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-vert-center"></span>
                        </button>
                        <button className={item.contentVerticalAlignment == 3 ? 'active' : ''}
                            aria-label="Bottom Align"
                            xd-qa-type="button"
                            xd-qa-name="Vertical Align Bottom"
                            onClick={async() => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['contentVerticalAlignment'] = 3;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item.parentContainer.parentComponent.name, item.name, "contentVerticalAlignment"]).onChange(3);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }}
                        >
                            <span className="icon align-vert-bottom"></span>
                        </button>
                    </div>
                </div>
                <div className="field flexField">
                    <div className="label">
                        Keep The Image In The Box
                    </div>
                    <div className="control">
                        {SliderCheckbox({
                            xdQaName: "isCoverMode",
                            value: item.isCoverMode,
                            onChange: async (value) => {
                                try{
                                    let product = await getProduct();
                                    let itemChanging = await product.getItemByName(item.name);
                                    itemChanging['isCoverMode'] = value;
                                    await product.setItem(itemChanging);
                                    await reloadItems();
                                    scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, 'isCoverMode']).onChange(value);
                                }
                                catch(error){
                                    console.log('Error:', error);
                                }
                            }
                        })}
                    </div>
                </div>
            </>
            : <></>
        }
        <div className="field flexField">
            <div className="label">
                Show In PDF
            </div>
            <div className="control">
                {SliderCheckbox({
                    xdQaName: "noPrint",
                    value: !item.visualizationPermissions?.noPrint,
                    onChange: async (value) => {
                        try{
                            let product = await getProduct();
                            let itemChanging = await product.getItemByName(item.name);
                            itemChanging['visualizationPermissions']["noPrint"] = !value;
                            await product.setItem(itemChanging);
                            await reloadItems();
                            scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, "visualizationPermissions", "noPrint"]).onChange(!value);
                        }
                        catch(error){
                            console.log('Error:', error);
                        }
                    }
                })}
            </div>
        </div>
        <div className="field flexField">
            <div className="label">
                Show In Editor
            </div>
            <div className="control">
                {SliderCheckbox({
                    xdQaName: "noShow",
                    value: !item.visualizationPermissions?.noShow,
                    onChange: async (value) => {
                        try{
                            let product = await getProduct();
                            let itemChanging = await product.getItemByName(item.name);
                            itemChanging['visualizationPermissions']['noShow'] = !value;
                            await product.setItem(itemChanging);
                            await reloadItems();
                            scopedState(dataProperties, [item._parentContainer.parentComponent.name, item.name, "visualizationPermissions", "noShow"]).onChange(!value);
                        }
                        catch(error){
                            console.log('Error:', error);
                        }
                    }
                })}
            </div>
        </div>
    </div>
}

const getMockedResult = (mockDataFormatted, value)=>{
    try{
        return getBindingResults(mockDataFormatted, value)
    }
    catch(e) {
        return `error: ${e}`
    }
}

const variableImageBindingExamples = [
    {name:"User Default Headshot", binding: "{{#if xd.user.defaultHeadshot}}{{xd.user.defaultHeadshot}}{{else}}{{xd.user.imageGallery.headshots.0.imageUrl}}{{/if}}"},
    {name:"User Default Headshot 2", binding: "{{xd.user.defaultHeadshot2}}"},

    {name:"Black Square Logo", binding:  "{{#if xd.office.orgPrefs.logo_st_blk.url}}{{xd.office.orgPrefs.logo_st_blk.url}}{{else}}{{#if xd.region.orgPrefs.logo_st_blk.url}}{{xd.region.orgPrefs.logo_st_blk.url}}{{else}}{{xd.company.orgPrefs.logo_st_blk.url}}{{/if}}{{/if}}"},
    {name:"Black Wide Logo", binding:  "{{#if xd.office.orgPrefs.logo_hori_blk.url}}{{xd.office.orgPrefs.logo_hori_blk.url}}{{else}}{{#if xd.region.orgPrefs.logo_hori_blk.url}}{{xd.region.orgPrefs.logo_hori_blk.url}}{{else}}{{xd.company.orgPrefs.logo_hori_blk.url}}{{/if}}{{/if}}"},
    {name:"Color Square Logo", binding: "{{#if xd.office.orgPrefs.logo_st_clr.url}}{{xd.office.orgPrefs.logo_st_clr.url}}{{else}}{{#if xd.region.orgPrefs.logo_st_clr.url}}{{xd.region.orgPrefs.logo_st_clr.url}}{{else}}{{xd.company.orgPrefs.logo_st_clr.url}}{{/if}}{{/if}}"},
    {name:"Color Wide Logo", binding: "{{#if xd.office.orgPrefs.logo_hori_clr.url}}{{xd.office.orgPrefs.logo_hori_clr.url}}{{else}}{{#if xd.region.orgPrefs.logo_hori_clr.url}}{{xd.region.orgPrefs.logo_hori_clr.url}}{{else}}{{xd.company.orgPrefs.logo_hori_clr.url}}{{/if}}{{/if}}"},
    {name:"White Square Logo", binding: "{{#if xd.office.orgPrefs.logo_st_bw.url}}{{xd.office.orgPrefs.logo_st_bw.url}}{{else}}{{#if xd.region.orgPrefs.logo_st_bw.url}}{{xd.region.orgPrefs.logo_st_bw.url}}{{else}}{{xd.company.orgPrefs.logo_st_bw.url}}{{/if}}{{/if}}"},
    {name:"White Wide Logo", binding:  "{{#if xd.office.orgPrefs.logo_hori_bw.url}}{{xd.office.orgPrefs.logo_hori_bw.url}}{{else}}{{#if xd.region.orgPrefs.logo_hori_bw.url}}{{xd.region.orgPrefs.logo_hori_bw.url}}{{else}}{{xd.company.orgPrefs.logo_hori_bw.url}}{{/if}}{{/if}}"},

    {name:"Listing Picture 1", binding: "{{xd.listing.pictures.0.pictureUrl}}"},
    {name:"Listing Picture 2", binding: "{{xd.listing.pictures.1.pictureUrl}}"},
    {name:"Listing Picture 3", binding: "{{xd.listing.pictures.2.pictureUrl}}"},
    {name:"Listing Picture 4", binding: "{{xd.listing.pictures.3.pictureUrl}}"},
    {name:"Listing Picture 5", binding: "{{xd.listing.pictures.4.pictureUrl}}"},
    {name:"Listing Picture 6", binding: "{{xd.listing.pictures.5.pictureUrl}}"},
    {name:"Listing Picture 7", binding: "{{xd.listing.pictures.6.pictureUrl}}"},
    {name:"Listing Picture 8", binding: "{{xd.listing.pictures.7.pictureUrl}}"},
    {name:"Listing Picture 9", binding: "{{xd.listing.pictures.8.pictureUrl}}"},
    {name:"Listing Picture 10", binding: "{{xd.listing.pictures.9.pictureUrl}}"},
    {name:"Listing Picture 11", binding: "{{xd.listing.pictures.10.pictureUrl}}"},
    {name:"Listing Picture 12", binding: "{{xd.listing.pictures.11.pictureUrl}}"},
    {name:"Listing Picture 13", binding: "{{xd.listing.pictures.12.pictureUrl}}"},
    {name:"Listing Picture 14", binding: "{{xd.listing.pictures.13.pictureUrl}}"},
    {name:"Listing Picture 15", binding: "{{xd.listing.pictures.14.pictureUrl}}"},
    {name:"Listing Picture 16", binding: "{{xd.listing.pictures.15.pictureUrl}}"},
];